import { ulid } from 'ulid';
import type { CampaignViewModel } from '@/graphql/generated';

type CampaignCloneInput = Pick<CampaignViewModel, 
  | 'name' 
  | 'description' 
  | 'startDate' 
  | 'endDate' 
  | 'isActive'
>;

/**
 * Clone a Campaign entity
 * 
 * - campaignId: NEW (regenerated)
 * - facilityId: Handled server-side (not included in CreateCampaignInput)
 * - All other fields: COPIED as-is
 */
export function cloneCampaign(source: CampaignCloneInput): CampaignCloneInput & { campaignId: string } {
  return {
    // New entity ID
    campaignId: ulid(),
    
    // Transform name to indicate copy
    name: `${source.name} (Copy)`,
    
    // Copy all other fields
    description: source.description,
    startDate: source.startDate,
    endDate: source.endDate,
    isActive: source.isActive,
  };
}

export type ClonedCampaign = ReturnType<typeof cloneCampaign>;
